
export class IacMenuContext {
    constructor() {

    }
}
